import { useMemo } from 'react';
import type { BusinessCapability } from '../../shell/session/domain/businessProfile';
import type { OrganizationBusinessProfile } from '../../shell/session/domain/businessProfile';
import {
  isOperationModeCapabilityOff,
  parseOperationMode,
} from '../../shell/session/domain/operationMode';
import { useBusinessProfileStore } from '../../shell/session/store/useBusinessProfileStore';
import { roundTipMoney } from './posCheckoutTip';

/** Propina cargada por staff en POS (no rider_tip ni tableside guest). */
export function hasPosStaffTipsCapability(
  capabilities: readonly BusinessCapability[] | null | undefined,
): boolean {
  return Boolean(capabilities?.includes('pos_tips'));
}

/** Mismo criterio que el dueño ve en Funciones + modo operación (ocultar al cobrar). */
export function isPosStaffTipsEnabled(
  profile: OrganizationBusinessProfile | null | undefined,
): boolean {
  if (!profile) return false;
  if (!hasPosStaffTipsCapability(profile.capabilities)) return false;
  const mode = parseOperationMode(profile.business_config);
  if (isOperationModeCapabilityOff(mode, 'pos_tips')) return false;
  return true;
}

export function usePosStaffTipsEnabled(): boolean {
  const profile = useBusinessProfileStore((s) => s.profile);
  return useMemo(() => isPosStaffTipsEnabled(profile), [profile]);
}

/** Perfil org para gates en callbacks (no está en SessionState). */
export function getOrganizationBusinessProfileForPos(): OrganizationBusinessProfile | null {
  return useBusinessProfileStore.getState().profile;
}

/** Nunca persistir propina si la UI/capability está apagada (evita P0001 capability_required). */
export function resolvePosStaffTipAmount(args: {
  tipIntentAmount: number;
  tipUiEnabled: boolean;
  staffTipsEnabled: boolean;
}): number {
  if (!args.staffTipsEnabled || !args.tipUiEnabled) return 0;
  return roundTipMoney(args.tipIntentAmount);
}
